module.exports = {
  headline: 'Din data & integritet är skyddad med Spotin',
  index: [

  ],
  terms: `
    <p>
    Den här data integritetspolicyn har uppdaterats av Spotin AB den 11:e Juli 2022.
    </p>

    <span>
    1.1
    </span> 
    <p class="m-list">
    Spotin AB värnar om din integritet och strävar efter att alltid skydda dina personuppgifter på bästa sätt. Det är Spotin AB:s målsättning 
    att följa alla vid var tid gällande lagar och regler för personuppgiftsskydd.Spotin AB ansvarar för att dessa Villkor och hantering av 
    personuppgifter uppfyller EUs allmänna dataskyddsförordning ("GDPR").
    </p>

    <span>
    1.2
    </span>
    <p class="m-list">
    Spotin AB (Org. nr: 559027-1549) Rådstugatan 7A, 972 38 Luleå, Sverige, är personuppgiftsansvarig för Spotin AB:s behandling av de 
    personuppgifter som du som Kund lämnar till tjänsten SPOTIN. 
    </p>

    <span>
    1.3
    </span>
    <p class="m-list">
    Om Spotin AB upptäcker att dina personuppgifter har behandlats i strid med gällande lagar och regler åtar sig Spotin AB att agera inom 
    72 timmar från sådan upptäckt i syfte att stävja sådan felaktig behandling.
    </p>

    <span>
    1.4
    </span>
    <p class="m-list">
    Spotin AB behandlar uppgifter som du som Kund själv lämnar till SPOTIN, t.ex. kontaktinformation och adressuppgifter. Genom användandet 
    av SPOTIN kan data även komma att samlas av tjänsteförmedlare där Spotin AB inte är delaktiga varken som personuppgiftsansvarig eller 
    som biträde, t.ex. ifall köphistorik registreras hos en betalningstjänst i samband med köp. Kund hänvisas till respektive 
    tjänsteförmedlares avtal för information om deras behandling av data.
    </p>

    <span>
    1.5
    </span>
    <p class="m-list">
    Inga känsliga personuppgifter såsom beskrivs inom GDPR sparas inom ramarna för SPOTIN. I fråga om skyddade adressuppgifter så ansvarar 
    Kund för säkerhållande av sådana uppgifter och ansvarar själv för dess lämplighet vid användning i SPOTIN.
    SPOTIN.
    </p>

    <span>
    1.6
    </span>
    <p class="m-list">
    Personuppgifter som inte längre är nödvändiga för uppfyllande av lagar, regler och avtal, exempelvis vid affärstransaktioner, tas 
    bort av SPOTIN. 
    </p>

    <span>
    1.7
    </span>
    <p class="m-list">
    Spotin AB behandlar Kundens personuppgifter för att administrera Kundens beställningar via SPOTIN. Kundens personuppgifter 
    kommer således att lämnas ut till Leverantörer och Betalningsförmedlare då detta är nödvändigt för att genomföra en beställning och 
    underlätta Kundens Köp. Information om respektive Leverantörs och Betalningsförmedlares behandling av personuppgifter framgår av 
    respektive Leverantörs och Betalningsförmedlares bestämmelser om personuppgiftsbehandling och/eller integritetspolicy, vilka Kunden 
    får del av i samband med ingående av Avtal med respektive Leverantör. 
    </p>

    <span>
    1.8
    </span>
    <p class="m-list">
    Kundens personuppgifter kan komma att användas av Spotin AB för identifikation av Kund vid lagd order eller vid registrering av 
    användare i Spotin, administration av ordrar och affärstransaktioner mot Spotin ABs leverantörer. Statistiska data kan komma att 
    användas i begränsad utsträckning för statistikändamål utan relation till specifika användare (ex. för statistik över geografiska områden 
    olika köp görs inom).   
    </p>

    <span>
    1.9
    </span>
    <p class="m-list">
    Om Kunden särskilt har samtyckt kan personuppgifter komma att användas av Spotin AB för direktmarknadsföring via SPOTIN från Spotin AB:s 
    samarbetspartners med anpassade erbjudanden via exempelvis e-post och/eller direktreklam från Leverantörer och Mediaägare.
    </p>

    <span>
    1.10
    </span>
    <p class="m-list">
    Spotin AB:s personuppgiftsbehandling kan även innebära samkörning med andra register inom Spotin ABs koncern och att dina personuppgifter 
    överförs till andra bolag inom Spotin AB:s koncern både inom och utom EU. Överföring av personuppgifter till länder utanför EU kräver att 
    det mottagande företaget följer delagar och regler för att hantera personuppgifter som upprätthålls inom EU, d.v.s. gällande 
    dataskyddsförordning (GDPR). Genom att godkänna Villkoren ger du så långt regler och lag tillåter ditt samtycke till denna överföring. 
    </p>

    <span>
    1.11
    </span>
    <p class="m-list">
    Du som Kund har rätt att gratis begära information om de personuppgifter som behandlas om dig som Kund genom SPOTIN. Om du vill ha sådan 
    information, ska en undertecknad begäran lämnas till Spotin AB. Begäran ska göras skriftligen och kan inte skickas med e-post. Du som Kund 
    har rätt att begära att uppgifterna rättas eller raderas. Radering av information endast förutsatt att 1.12 nedan också är uppfyllt. 
    </p>

    <span>
    1.12
    </span>
    <p class="m-list">
    Radering av information kan endast ske såvida inte informationen krävs för att följa skyldigheter i gällande lagar, regler och avtal.
    Exempelvis information som krävs för att Spotin AB, Leverantör och Betalningsförmedlare ska kunna uppfylla din order. 
    </p>
  `,
};



// WEBPACK FOOTER //
// ./pages/content/privacy_SV.js